import { IOptionCustomized } from '../../stage-properties.model';

export function getLastNumber(str: string): number {
  const matches = str.match(/\d+$/);
  return matches ? parseInt(matches[0]) : NaN;
}

export const filterActions = (
  actionsOptions: IOptionCustomized[],
  type?: string
) => {
  switch (type) {
    case 'all':
      return actionsOptions;
    case 'workflow':
      return actionsOptions.filter(
        (action) =>
          action.actionLevel.toLowerCase().includes('flow') ||
          action.actionType.toLowerCase().includes('flow') ||
          action.actionType.toLowerCase().includes('triggerWorkflow') ||
          action.actionType.toLowerCase().includes('workflow')
      );
    case 'task':
      return actionsOptions.filter(
        (action) =>
          action.actionType.toLowerCase().includes('task') ||
          action.actionType.toLowerCase().includes('taskGroup')
      );
    default:
      return actionsOptions.filter(
        (action) =>
          !action.actionLevel.toLowerCase().includes('flow') &&
          !action.actionType.toLowerCase().includes('flow') &&
          !action.actionType.toLowerCase().includes('task') &&
          !action.actionType.toLowerCase().includes('taskGroup')
      );
  }
};
